import { Link } from 'react-router-dom'
import Seo from '../components/Seo.jsx'

const UPDATED = 'July 2026'

export default function Privacy() {
  return (
    <main className="page">
      <Seo
        title="Privacy Policy | CalculateMyPeptides"
        description="How CalculateMyPeptides handles your data: account information, saved calculations, and privacy practices for our peptide calculator and education tools."
      />
      <div className="container page-narrow legal">
        <h1 className="section-title">Privacy Policy</h1>
        <p className="muted small">Last updated: {UPDATED}</p>

        <p>
          This Privacy Policy explains what information CalculateMyPeptides collects, how we use it, and the
          choices you have. By using the Site, you agree to this policy.
        </p>

        <h2>Information we collect</h2>
        <ul>
          <li><strong>Account details</strong> — the email address (and optional name) you provide when you register.</li>
          <li><strong>Your content</strong> — the calculations and dosing-calendar entries you choose to save.</li>
          <li><strong>Marketing opt-in</strong> — if you check the sponsor-email box, we store your email to send occasional offers.</li>
          <li><strong>Local device data</strong> — small values stored in your browser (such as your light/dark theme choice and whether you’ve seen the promo popup).</li>
        </ul>
        <p>We do not intentionally collect sensitive personal data, and we ask that you not enter any.</p>

        <h2>How we use it</h2>
        <ul>
          <li>To provide your account and save/sync your calculations and calendar.</li>
          <li>To operate, secure, and improve the Site.</li>
          <li>To send sponsor offers only if you opted in (you can opt out at any time).</li>
        </ul>

        <h2>How your data is stored</h2>
        <p>
          Your account and saved content are stored securely using trusted third-party infrastructure
          providers. Access is restricted so that each account can only read and write its own data, and
          passwords are handled by our authentication provider rather than stored by us in plain text.
        </p>

        <h2>Sharing</h2>
        <p>
          We do not sell your personal information. We share data only with the service providers that help us
          operate the Site, and only as needed to provide the service or when required by law. Clicking a
          sponsor or partner link takes you to a third party with its own privacy practices.
        </p>

        <h2>Cookies &amp; local storage</h2>
        <p>
          We use browser local storage for essential preferences and session functionality rather than
          advertising trackers. Analytics or advertising tools, if added later, will be disclosed here.
        </p>

        <h2>Data retention &amp; deletion</h2>
        <p>
          We keep your data while your account is active. You may request deletion of your account and
          associated data by contacting us; we’ll remove it within a reasonable period, except where retention
          is legally required.
        </p>

        <h2>Children</h2>
        <p>The Site is intended for adults (21+) and is not directed to children.</p>

        <h2>Your choices</h2>
        <p>
          You can update your saved content in the app, opt out of marketing emails, and request access or
          deletion of your data. Depending on where you live, you may have additional rights under laws such as
          the GDPR or CCPA.
        </p>

        <h2>Changes</h2>
        <p>We may update this policy; material changes will be reflected by the “last updated” date above.</p>

        <h2>Contact</h2>
        <p>For privacy questions or requests, reach us through the contact options on the Site.</p>

        <p className="muted small" style={{ marginTop: 24 }}>
          See also our <Link to="/terms">Terms &amp; Conditions</Link>.
        </p>
      </div>
    </main>
  )
}
